module.exports = __webpack_public_path__ + "@/assets/img/018-girl-9.79930339.svg";